import _ from 'lodash';

export default {
  methods: {
    openNewProduct(productId, path = null) {
      window.location = this.createNewProductLink(productId, path)
    },
    openOldProduct(productId, path) {
      window.location = this.createOldProductLink(productId, path)
    },
    createNewProductLink(productId, path = null) {
      let query = _.assign({}, this.$route.query, {
        path: path
      })
      if (null === query.path || undefined === query.path) {
        query = _.omit(query, 'path')
      }
      query = this.urlEncodeObject(query)
      return `/admin/product/view/${productId}?${query}`
    },
    createOldProductLink(productId, path = null) {
      let query = _.assign({}, this.$route.query, {
        pID    : productId,
        action : 'new_product',
        path   : path
      })
      if (null === query.path || undefined === query.path) {
        query = _.omit(query, 'path')
      }
      query = this.urlEncodeObject(query)
      return `/admin/categories.php?${query}`
    }
  }
}
